import "./Main.scss";

import Flickity from './General/SliderInit';

// Make Flickity global (used for events)
window.Flickity = Flickity;

// Resize Flickity on Page Load
document.addEventListener('DOMContentLoaded', event => {
    setTimeout(function() {
        [...document.querySelectorAll('[data-flickity]')].forEach(slider => {
            const flkty = Flickity.data(slider);
            const autoplayOnlyOnMobile = slider.classList.contains('autoplay-only-on-mobile');
            const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0)
            const isMobile = vw < 769;

            if (flkty) {
                flkty.resize();

                if (autoplayOnlyOnMobile && !isMobile) {
                    flkty.stopPlayer();
                };
            }
        });

        //Count elements in slider Pricetable
        const priceTableContainer = document.querySelector('.pricetable__table.slider');
        const priceTableSliderItems = document.querySelector('.pricetable__table.slider .flickity-slider');

        if (priceTableContainer) {
            const flkty = Flickity.data(priceTableContainer);
            const countSlide = priceTableSliderItems.children.length;

            priceTableContainer.classList.add('count-' + countSlide);

            flkty.resize();
        }
    }, 300);
});


